import { observer } from 'mobx-react';
import { observable, action, makeObservable } from 'mobx';
import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export interface Props {
  title: React.ReactNode;
  icon: string;
  href: string;
  badge?: string | number;
  openIfPathIncludes?: string;
}

@observer
export class PortalAsideCategory extends React.Component<Props, {}> {
  static contextType = StoreContext;
  declare context: Store;

  @observable isCategoryManualOpen: boolean | undefined;

  constructor(props: Props) {
    super(props);
    makeObservable(this);
  }

  get isCategoryOpen() {
    if (typeof this.isCategoryManualOpen !== 'undefined') {
      return this.isCategoryManualOpen;
    }
    return this.isCategoryDefaultOpen;
  }

  get isCategoryDefaultOpen() {
    const { pathurl } = this.context.requestStore.requestLocation;
    const { href, openIfPathIncludes } = this.props;
    if (pathurl.includes(openIfPathIncludes)) {
      return true;
    }
    return false;
  }

  render() {
    const { title, icon, children, href, badge } = this.props;

    return (
      <li
        className={`menu-item menu-item-submenu${this.isCategoryOpen ? ' menu-item-open' : ''}`}
        aria-haspopup="true"
        data-ktmenu-submenu-toggle="hover"
      >
        <a onClick={action(() => (this.isCategoryManualOpen = !this.isCategoryOpen))} className="menu-link menu-toggle">
          <i className={`menu-icon ${icon}`} />
          <span className="menu-text">{title}</span>
          {badge && (
            <span className="menu-label">
              <span className="label label-rounded label-brand">{badge}</span>
            </span>
          )}
          <i className="menu-arrow" />
        </a>
        <div className="menu-submenu">
          <span className="menu-arrow" />
          <ul className="menu-subnav">{children}</ul>
        </div>
      </li>
    );
  }
}
